import api from '../core/api';
import type {
  CustomResponse,
  TokenConfiguration,
  TokenConfigurationRequest,
} from '../../types/auth/TokenConfigurationTypes';

const RESOURCE = '/auth/token-configuration';

const tokenConfigurationApi = {
  get: () => api.get<CustomResponse<TokenConfiguration>>(RESOURCE),
  create: (payload: TokenConfigurationRequest) =>
    api.post<CustomResponse<TokenConfiguration>>(RESOURCE, payload),
  update: (payload: TokenConfigurationRequest) =>
    api.put<CustomResponse<TokenConfiguration>>(RESOURCE, payload),
  remove: () => api.delete<CustomResponse<null>>(RESOURCE),
};

export default tokenConfigurationApi;
